import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { getStatusBadge } from '../../common/types/productStatus';
import { buildApiUrl } from '../../common/api';
import '../../common/theme/tokens.css';

export default function DettaglioProdotto() {
  const { id } = useParams();
  const [prodotto, setProdotto] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(buildApiUrl(`/api/prodotti/${id}`))
      .then((r) => r.json())
      .then((j) => setProdotto(j.data))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <div className="min-h-screen bg-[#FFFEFA] flex items-center justify-center text-gray-400">Caricamento...</div>;
  }

  if (!prodotto) {
    return (
      <div className="min-h-screen bg-[#FFFEFA] flex flex-col items-center justify-center gap-4">
        <p>Prodotto non trovato</p>
        <Link to="/catalogo" className="text-[#c78244] underline">Torna al catalogo</Link>
      </div>
    );
  }

  const badge = getStatusBadge(prodotto.status);
  const fornitore = prodotto.candidatura?.dati_fornitore?.ragioneSociale;
  const baseUrl = import.meta.env.VITE_API_BASE_URL || '/backend';

  return (
    <div className="min-h-screen bg-[#FFFEFA]">
      <div className="max-w-4xl mx-auto px-4 py-10">
        <Link to="/catalogo" className="text-sm text-[#c78244] underline mb-6 inline-block">← Catalogo</Link>

        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="mang-card overflow-hidden">
          {prodotto.foto?.length > 0 && (
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-1">
              {prodotto.foto.map((f) => (
                <img
                  key={f.id}
                  src={`${baseUrl}/api/file/${f.path}`}
                  alt={prodotto.nome}
                  className="w-full aspect-square object-cover"
                />
              ))}
            </div>
          )}

          <div className="p-8">
            <div className="flex items-start justify-between gap-4 mb-4">
              <h1 className="text-2xl font-bold text-gray-800">{prodotto.nome}</h1>
              <span className={`mang-badge ${badge.className}`}>{badge.label}</span>
            </div>

            {prodotto.categoria && (
              <p className="text-sm text-gray-400 uppercase tracking-wide mb-2">{prodotto.categoria}</p>
            )}
            {fornitore && (
              <p className="text-[#c78244] font-semibold mb-4">Produttore: {fornitore}</p>
            )}
            {prodotto.descrizione && (
              <p className="text-gray-600 leading-relaxed">{prodotto.descrizione}</p>
            )}
            {prodotto.costoProduzione && (
              <p className="mt-4 text-lg font-bold text-gray-800">
                Da € {Number(prodotto.costoProduzione).toFixed(2)}
              </p>
            )}
          </div>
        </motion.div>
      </div>
    </div>
  );
}
